import { tabClasses } from "@mui/material";

/**
 * @param base Base MUI Theme object, left as `any` so we don't need to import types here
 * @returns MUI ThemeOptions
 */
const getCustomerTheme = (base: any) => ({
  palette: {
    primary: {
      main: "#323F4A",
      light: "#435363",
      dark: "#29323B",
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          [`&.${tabClasses.selected}`]: {
            color: "#323F4A",
          },
        },
      },
    },
  },
});

export default getCustomerTheme;
